import React from 'react';
import FormatHelpers from '../helpers/FormatHelpers';

const PROBABILIDADE_DESTAQUE = 70;

/** Cards do topo do painel, calculados sobre todos os pacientes da fila (não só a página). */
const IndicadoresPainel = ({ pacientes }) => {
  const lista = pacientes ?? [];
  const esperas = lista.map(paciente => Number(paciente.valor) || 0);
  const total = lista.length;

  const acimaDoLimite = lista.filter(paciente => (Number(paciente.previsaointernacao) || 0) >= PROBABILIDADE_DESTAQUE).length;
  const comAtendimentoAnterior = lista.filter(paciente => paciente.contexto).length;
  const esperaMedia = total > 0 ? esperas.reduce((soma, espera) => soma + espera, 0) / total : 0;
  const maiorEspera = esperas.reduce((maior, espera) => Math.max(maior, espera), 0);

  return (
    <div className="indicadores">
      <div className='cardIndicador'>
        <div className="cardIndicador-titulo">Pacientes na fila</div>
        <div className="cardIndicador-valor">{total}</div>
      </div>
      <div className='cardIndicador destaque'>
        <div className="cardIndicador-titulo">{'Probabilidade ≥ ' + PROBABILIDADE_DESTAQUE + '%'}</div>
        <div className="cardIndicador-valor">{acimaDoLimite}</div>
      </div>
      <div className='cardIndicador'>
        <div className="cardIndicador-titulo">Reprocura / readmissão 72h</div>
        <div className="cardIndicador-valor">{comAtendimentoAnterior}</div>
      </div>
      <div className='cardIndicador'>
        <div className="cardIndicador-titulo">Espera média na fila</div>
        <div className="cardIndicador-valor">{FormatHelpers.formatarDuracao(esperaMedia)}</div>
      </div>
      <div className='cardIndicador destaque'>
        <div className="cardIndicador-titulo">Maior espera</div>
        <div className="cardIndicador-valor">{FormatHelpers.formatarDuracao(maiorEspera)}</div>
      </div>
    </div>
  );
};

export default IndicadoresPainel;
